/** Seeded PRNG (mulberry32). Deterministic on every platform; not for cryptography. */
export interface Rng {
  state: number
}

/**
 * The generator's state object (D-014). A class, not a literal: a `{ state }` literal shares its map with every other
 * literal whose first key is `state` (UI models store strings there), so the field can turn tagged, and a state of
 * 2^31 or more (half of all draws) is not a small integer: each such `nextFloat` then allocated a heap number.
 */
class RngState implements Rng {
  state = 0
}

export function createRng(seed: number): Rng {
  const rng = new RngState()
  rng.state = seed >>> 0
  return rng
}

/** Returns a float in [0, 1) and advances the generator. */
export function nextFloat(rng: Rng): number {
  rng.state = (rng.state + 0x6d2b79f5) >>> 0
  let t = rng.state
  t = Math.imul(t ^ (t >>> 15), t | 1)
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296
}

export function range(rng: Rng, min: number, max: number): number {
  return min + (max - min) * nextFloat(rng)
}
